import { render } from "./CadastrarCorretor.vue?vue&type=template&id=10be8626&scoped=true"
import script from "./CadastrarCorretor.vue?vue&type=script&lang=js"
export * from "./CadastrarCorretor.vue?vue&type=script&lang=js"

import "./CadastrarCorretor.vue?vue&type=style&index=0&id=10be8626&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10be8626"]])

export default __exports__